<template>
  <div>
    <div class="page_maincontent main-container">
      <div class='top-content'>
        <h3 class='desktop-only'>INVENTORY SEARCH</h3>
        <div class='button-section mobile-full-width mobile-padding'>
          <button v-if='salesClass === 0' v-bind:class='!filterModel.isUsed ? "button-yellow": "button-grey"'
            class="mobile-padding" @click='onNewFilter'
            v-bind:style="[filterModel.isUsed ? {'background-color':'#fff',  'color': '#000' } : borderStyle]">
            NEW
          </button>
          <button v-if='salesClass === 0' v-bind:class='filterModel.isUsed ? "button-yellow": "button-grey"'
            class="mobile-padding" style="width:51%;margin:-3px" @click='onUsedFilter'
            v-bind:style="[filterModel.isUsed ? borderStyle : {'background-color':'#fff',  'color': '#000' }]">
            USED
          </button>
        </div>
        <div class='sort-section mobile-full-width mobile-padding'>
          <button class="button-grey mobile-only" @click='onMobileFilter'>
            Filter
          </button>
          <div class='moblie-float'>
            <span class='desktop-only'>Sort by:</span>
            <select v-model="filterModel.sort" @change='onSortChange'>
              <option v-for="(opt, key) in sortOptions" :key='key' :value="opt.value">{{opt.text}}</option>
            </select>
          </div>
        </div>
      </div>
      <div class='filter-сolumn desktop-only'>

        <inventory-filter @searchClick="onSearch()" :loading="!isLoaded" />

      </div>
      <div v-if='isLoaded' class='vehical-content-list mobile-full-width mobile-padding'>
        
        <specials-link :stylesObj="borderStyle"/>
        
        <div v-if="invetoryList && invetoryList.items.length > 0">
          <div v-for='(item,key)  in invetoryList.items' :key='key' style="margin-top:25px;margin-bot:25px;">
            <InventoryListItem :item="item" :borderStyle="borderStyle" />
          </div>
          <div style="clear:both"></div>

          <div class='padging-container' v-if='invetoryList.totalPages > 1'>
            <img src='../../assets/icons/black/rewind.png' v-if='invetoryList.pageNumber > 2' @click='onFirstPage' />
            <img src='../../assets/icons/black/back1.png' v-if='invetoryList.pageNumber != 1' @click='onPrevPage' />
            <span> {{invetoryList.pageNumber}} of {{invetoryList.totalPages}}</span>
            <img src='../../assets/icons/black/next1.png'
              v-if='invetoryList.totalPages != 1 && invetoryList.totalPages > 0 && filterModel.page != invetoryList.totalPages'
              @click='onNextPage' />
            <img src='../../assets/icons/black/fast-forward.png'
              v-if='invetoryList.totalPages != 1 && invetoryList.totalPages > 0  && filterModel.page != invetoryList.totalPages && filterModel.page !=  (invetoryList.totalPages - 1)'
              @click='onLastPage' />
          </div>
        </div>

        <div class='padging-container' v-if='invetoryList.totalPages == 0 || invetoryList.items.length === 0'>
          <span>NO RESULT</span>
        </div>

      </div>
      <div v-if='!isLoaded' class='loader-container' color="#f9f300">
        <loader :animation-duration="2500" :rhombus-size="25" color="#f9f300" />
      </div>
    </div>

  </div>
</template>

<script>
  import {
    mapState,
    mapActions,
    mapGetters
  } from 'vuex'
  import {
    LoopingRhombusesSpinner
  } from 'epic-spinners'
  import InventoryFilterDealertrend from '@/components/inventory/dealertrend-filter'
  import InventoryListItem from '@/components/inventory/inventory-list-item'
  import {
    InventoryProviderType
  } from '@/shared/enums/inventory.js'

  import SpecialsLink from '@/components/inventory/specials-link'

export default {
    name: 'dealertrend-content',
    components: {
      'specials-link': SpecialsLink,
      'loader': LoopingRhombusesSpinner,
      'inventory-filter': InventoryFilterDealertrend,
      InventoryListItem
    },
    data () {
      return {
        isLoaded: false,
        isActive: false,
        sortOptions: [{
          value: 'make_asc',
          text: 'Make: A to Z'
        },
        {
          value: 'make_desc',
          text: 'Make: Z to A'
        },
        {
          value: 'price_desc',
          text: 'Price: Highest First'
        },
        {
          value: 'price_asc',
          text: 'Price: Lowest First'
        },
        {
          value: 'year_desc',
          text: 'Year: Highest First'
        },
        {
          value: 'year_asc',
          text: 'Year: Lowest First'
        },
        {
          value: 'added_asc',
          text: 'Date: Oldest First'
        },
        {
          value: 'added_desc',
          text: 'Date: Newest First'
        }
        ],
        providerType: InventoryProviderType
      }
    },
    mounted () {
      this.isLoaded = true
    },
    computed: {
      ...mapState({
        invetoryList: state => state.inventory.invetoryList,
        salesClass: state => state.common.salesClass,
        dealerSalesClassEnum: state => state.inventory.dealerSalesClassEnum,
        customization: state => state.common.customization,
        inventoryType: state => state.inventory.providerType
      }),
      ...mapGetters({
        filterModel: 'inventory/getFilterModel'
      }),
      borderStyle: function () {
        var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
        var backgroundStyle = this.customization.mainColor
        var colorStyle = this.customization.fontColor
        return {
          border: borderStyle,
          background: backgroundStyle,
          color: colorStyle
        }
      }
    },
    methods: {
      ...mapActions({
        getVehicalList: 'inventory/loadVehicalList',
        updateFilter: 'inventory/updateFilter',
        updateFilterToDefault: 'inventory/updateFilterToDefault',
        loadMakes: 'inventory/loadMakes',
        loadCurrentVehical: 'inventory/loadCurrentVehical'
      }),
      async onNextPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.pageNumber + 1
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onFirstPage () {
        this.isLoaded = false
        this.filterModel.page = 1
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onLastPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.totalPages
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onPrevPage () {
        this.isLoaded = false
        this.filterModel.page = this.invetoryList.pageNumber - 1
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onSortChange () {
        this.isLoaded = false
        this.filterModel.page = 1
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onUsedFilter () {
        this.resetFilterModel()
        this.isLoaded = false
        this.filterModel.isUsed = true
        this.filterModel.sort = 'price_asc'
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      async onNewFilter () {
        this.resetFilterModel()
        this.isLoaded = false
        this.filterModel.isUsed = false
        this.filterModel.sort = 'added_asc'
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      onMobileFilter () {
        this.$router.load({
          url: `inventory/filter`
        })
      },
      async onSearch () {
        this.isLoaded = false
        await this.updateFilter(this.filterModel)
        await this.getVehicalList()
        this.isLoaded = true
      },
      gotoVehical (id) {
        if (this.isActive !== true) {
          this.isActive = true
          this.isLoaded = false
          this.loadCurrentVehical(id).then(function () {
            this.$router.load({
              url: 'vehicle/' + id
            })
            this.isActive = false
          }.bind(this))
        }
      },
      resetFilterModel () {
        this.filterModel.model = null
        this.filterModel.make = null
        this.filterModel.bodyType = null
        this.filterModel.yearFrom = null
        this.filterModel.yearTo = null
        this.filterModel.priceTo = null
        this.filterModel.priceFrom = null
        this.filterModel.trim = null
        this.filterModel.page = 1
        this.filterModel.sort = this.filterModel.isUsed ? 'price_asc' : 'added_asc'
        this.updateFilterToDefault(this.filterModel).then(function () {
          this.loadMakes()
        }.bind(this))
      }
    }
  }
</script>

<style scoped>
  .main-container {
    max-width: 1280px;
    margin: 0 auto;
    padding-left: 25px;
    padding-right: 25px;
    height: 100%;
  }

  .mobile-only {
    display: none;
  }

  .table {
    display: table;
    padding-top: 20px;
  }

  .table-row {
    display: table-row
  }

  .table-cell {
    display: table-cell;
    /* padding-left: 10px; */
    padding-right: 10px;
    padding-bottom: 5px;
    max-width: 150px;
  }

  .bold {
    font-weight: bold;
  }

  .filter-сolumn {
    width: 25%;
    float: left;
  }

  .vehical-content-list {
    width: 70%;
    float: left;
    padding-left: 60px;
    height: 670px;
    overflow: hidden;
    overflow-y: auto;
    padding-bottom: 10px
  }

  .loader-container {
    width: 49%;
    float: left;
    text-align: center;
    padding-top: 15%;
  }

  .looping-rhombuses-spinner {
    display: inline-block;
  }

  .car-image {
    width: 290px;
    /* height: 160px; */
    object-fit: cover;
    display: inline-block
  }

  .car-description {
    display: inline-block;
    vertical-align: top;
    padding-left: 15px;
  }

  .car-description .title {
    font-size: 18px;
    font-weight: bold;
  }

  .button-yellow,
  .button-grey {
    width: 30%;
    margin: 10px 0 0 0;
    font-weight: normal;
    text-align: center;
    cursor: pointer;
    font-size: 18px;
    background-color: #f9f301;
    color: #222222;
    border: none;
    height: 45px;
  }

  .button-grey {
    background-color: #EEEEEE;
  }

  .top-content {
    padding-top: 25px;
    margin-bottom: 20px;
  }

  .button-section {
    width: 25%;
    float: left;
    padding-top: 10px;
  }

  .sort-section {
    width: 290px;
    display: inline-block;
    padding-left: 60px;
  }

  .sort-section span {
    font-weight: bold;
    font-size: 18px;
  }

  .button-section .button-yellow,
  .button-section .button-grey {
    width: 49%;
    font-size: 14px;
    font-weight: bold;
  }

  select {
    width: 100%;
    height: 35px;
    font-size: 18px;
    padding-left: 5px;
  }

  h5 {
    font-weight: bold;
    padding: 10px 0 10px 0;
  }

  .padging-container {
    text-align: center;
    padding: 25px;
  }

  .padging-container img {
    width: 25px;
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
  }

  .padging-container span {
    vertical-align: bottom;
    height: 31px;
    display: inline-block;
  }

  .car-image-container {
    position: relative;
    width: 35%;
    height: auto;
    float: left;
  }

  .car-image-container img {
    width: 100%;
    max-height: 200px;
  }

  @media (max-width: 1249px) {
    .main-container {
      padding-left: 10px;
      padding-right: 10px;
    }

    .loader-container {
      width: 76%;
    }

    .desktop-only {
      display: none;
    }

    .mobile-full-width {
      width: 100%
    }

    .mobile-padding {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }

    .moblie-float {
      width: 69%;
      float: right;
      padding-top: 10px;
    }

    select {
      height: 45px;
    }

    .mobile-only {
      display: inline-block;
    }

    .price-mobile {
      position: absolute;
      right: 0px;
      top: 0px;
      margin: 0px;
      width: 45%;
      font-size: 14px;
    }

    .car-image-container {
      width: 50%
    }

    .car-description {
      width: 45%;
      float: left;
    }

    .mobile-block {
      display: block;
    }

    .car-description {
      font-size: 14px !important;
    }

    .vehical-content-list {
      height: auto;
      overflow-y: hidden;
    }
  }
</style>



// WEBPACK FOOTER //
// dealertrend-content.vue?05a76836